import type { ClientImageMetaField } from '@/ai/image/client-meta';

export type AdminV2ImageConstraintsForClientMeta = {
  allowedMimeTypes?: readonly unknown[];
  colorModes?: readonly unknown[];
  minWidth?: unknown;
  minHeight?: unknown;
  maxWidth?: unknown;
  maxHeight?: unknown;
  maxMegapixels?: unknown;
};

export function getRequiredAdminV2ClientImageMetaFields(
  constraints: AdminV2ImageConstraintsForClientMeta
): ClientImageMetaField[] {
  const required = new Set<ClientImageMetaField>();
  if ((constraints.allowedMimeTypes?.length ?? 0) > 0) {
    required.add('format');
  }
  if ((constraints.colorModes?.length ?? 0) > 0) {
    required.add('hasTransparentPixels');
  }
  if (
    constraints.minWidth !== undefined ||
    constraints.maxWidth !== undefined
  ) {
    required.add('width');
  }
  if (
    constraints.minHeight !== undefined ||
    constraints.maxHeight !== undefined
  ) {
    required.add('height');
  }
  if (constraints.maxMegapixels !== undefined) {
    required.add('width');
    required.add('height');
  }
  return [...required];
}
